import {theme} from "./QuestionApplicationWrapper.styles";

require('./bootstrap');

import React, {PureComponent} from 'react';
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles/index';
import AutoPanel from "./AutoPanel";
import {HashRouter} from 'react-router-dom'
import {Route} from 'react-router'
import {default as QuestionApp} from "./QuestionApplication";
import ReactDOM from "react-dom";
import LoginForm from "./AutoPanel/components/LoginForm/LoginForm";

class AutoPanelWrapper extends PureComponent {
    state = {
        authenticated: false,
    }

    getMuiTheme() {

        let themeWithPalette = {}
        let primaryColor = {
            50: "#e1f5fe",
            100: "#b3e5fc",
            200: "#81d4fa",
            300: "#4fc3f7",
            400: "#04afff",
            500: "#039be5",
            600: "#0288d1",
            700: "#0277bd",
            800: "#01579b",
            A100: "#80d8ff",
            A200: "#40c4ff",
            A400: "#00b0ff",
            A700: "#0091ea"
        };

        let secondaryColor = {
            50: "#fffde7",
            100: "#fff9c4",
            200: "#fff59d",
            300: "#fff176",
            400: "#f3ca1b",
            500: "#f5ba00",
            600: "#fdd835",
            700: "#fbc02d",
            800: "#f9a825",
            900: "#f57f17",
            A100: "#ffff8d",
            A200: "#ffff00",
            A400: "#ffea00",
            A700: "#ffd600"
        };

        themeWithPalette.palette = {
            primary: primaryColor,
            secondary: secondaryColor,
        }

        return createMuiTheme(themeWithPalette)
    }

    postLogin = () => {
        this.setState({authenticated: true})
    }

    render() {
        const muiTheme = this.getMuiTheme()
        const {authenticated} = this.state
        return (
            <>
                <MuiThemeProvider theme={muiTheme}>
                    {!authenticated && <LoginForm success={this.postLogin}/>}
                    {authenticated && <AutoPanel src={process.env.MIX_API_URL}/>}
                </MuiThemeProvider>
            </>)
    };
}

export default AutoPanelWrapper;

ReactDOM.render(<AutoPanelWrapper/>, document.getElementById('autoPanel'));
